import { Button } from '~/modules/@shared/components';

type ActionButtonProps = {
  label: string;
  isDisabled: boolean;
  isLoading?: boolean;
  onClick: () => void;
};

export default function ActionButton({ label, isDisabled, onClick, isLoading = false }: ActionButtonProps) {
  return (
    <Button autoFocus variant="contained" disabled={isDisabled} onClick={onClick} isLoading={isLoading}>
      {label}
    </Button>
  );
}
